import React from 'react';

const Loader = () => {
  return (
    <div className="p-8">
      <img
        className=" mx-auto p-2.5 max-w-full w-24 animate-spin"
        src={process.env.PUBLIC_URL + '/img/loader.png'}
        alt="logo"
      />
    </div>
  );
};

export default Loader;
